"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.string.ends-with");

require("core-js/modules/es6.function.name");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.number.constructor");

var _commonUpload = _interopRequireDefault(require("@/views/cms/common/commonUpload"));

var _validate = require("@/utils/validate");

var _send = require("@/api/cms/send");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  name: 'DeliveryKuaidi',
  components: {
    CommonUpload: _commonUpload.default
  },
  props: {
    form: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    sendStatus: {
      type: Number,
      default: null
    },
    deliveryLog: {
      type: Object,
      default: null
    },
    customerInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    submitting: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    initiator: {
      type: String,
      default: ''
    },
    initiateTime: {
      type: String,
      default: ''
    },
    sendTaskId: {
      type: [String, Number],
      default: null
    },
    contractList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      auditing: false
    };
  },
  computed: {
    previewAttachmentList: function previewAttachmentList() {
      var _this = this;

      var data = this.form.expressAttachment;
      if (!data) return [];

      try {
        var raw = typeof data === 'string' ? JSON.parse(data) : data;
        var imgPreviewPrefix = this.$store.getters.imgPreviewPrefix || '';
        var filePreviewPrefix = this.$store.getters.filePreviewPrefix || '';
        return raw.map(function (item) {
          var parsed = typeof item === 'string' ? JSON.parse(item) : item;
          var name = parsed.alias || parsed.localName || parsed.realName || '';

          var isImage = _this.isImageFile(name);

          var prefix = isImage ? imgPreviewPrefix : filePreviewPrefix;
          return {
            url: parsed.url || prefix + parsed.realName,
            name: name,
            isImage: isImage
          };
        });
      } catch (_unused) {
        return [];
      }
    },
    expressOrderPhotoList: function expressOrderPhotoList() {
      return this.parsePhotoList(this.deliveryLog && this.deliveryLog.expressOrderPhoto);
    },
    expressCollectionPhotoList: function expressCollectionPhotoList() {
      return this.parsePhotoList(this.deliveryLog && this.deliveryLog.expressCollectionPhoto);
    },
    deliveryChecklistPhotoList: function deliveryChecklistPhotoList() {
      return this.parsePhotoList(this.deliveryLog && this.deliveryLog.deliveryChecklistPhoto);
    },
    deliveryLoadingCompletePhotoList: function deliveryLoadingCompletePhotoList() {
      return this.parsePhotoList(this.deliveryLog && this.deliveryLog.deliveryLoadingCompletePhoto);
    }
  },
  methods: {
    // ==================== 审核方法 ====================
    handleReject: function handleReject() {
      var _this2 = this;

      if (!this.form.csAuditOpinion || !this.form.csAuditOpinion.trim()) {
        this.$message.warning('请填写您的审批意见');
        return;
      }

      this.$confirm('确定驳回该发货单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.doAudit(1011);
      }).catch(function () {});
    },
    handleApprove: function handleApprove() {
      var _this3 = this;

      this.$confirm('确定同意该发货单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.doAudit(1010);
      }).catch(function () {});
    },
    doAudit: function doAudit(status) {
      var _this4 = this;

      this.auditing = true;
      var contractNumber = this.contractList && this.contractList.length > 0 ? this.contractList[0].contractNumber || this.contractList[0].contractNo || this.contractList[0].custContractNo || '' : '';
      (0, _send.addSendTaskLog)({
        sendTaskId: this.sendTaskId,
        sendNumber: this.form.deliveryNo || '',
        contractNumber: contractNumber,
        step: String(status),
        remark: this.form.csAuditOpinion || ''
      }).then(function () {
        _this4.$message.success(status === 1011 ? '已驳回' : '已同意');

        _this4.$emit('audit-done');
      }).catch(function (error) {
        console.error('审核操作失败:', error);

        _this4.$message.error('操作失败，请重试');
      }).finally(function () {
        _this4.auditing = false;
      });
    },
    // ==================== 附件处理 ====================
    isImageFile: function isImageFile(fileName) {
      if (!fileName) return false;
      var imgExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp'];
      var ext = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
      return imgExtensions.includes(ext);
    },
    downloadAttachment: function downloadAttachment(item) {
      if (item.url) {
        fetch(item.url, {
          mode: 'cors'
        }).then(function (res) {
          return res.blob();
        }).then(function (blob) {
          var blobUrl = URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = blobUrl;
          a.download = item.name;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(blobUrl);
        }).catch(function () {
          window.open(item.url, '_blank');
        });
      }
    },
    handleAttachmentUpload: function handleAttachmentUpload(filePaths) {
      this.form.expressAttachment = JSON.stringify(filePaths);
      this.$emit('attachment-change', filePaths);
    },
    handleAttachmentDel: function handleAttachmentDel(filePaths) {
      this.form.expressAttachment = filePaths.length > 0 ? JSON.stringify(filePaths) : '';
      this.$emit('attachment-change', filePaths);
    },
    handleOrderUpload: function handleOrderUpload(filePaths) {
      this.form.expressOrderPhoto = JSON.stringify(filePaths);
      this.$emit('attachment-change', filePaths);
    },
    handleOrderDel: function handleOrderDel(filePaths) {
      this.form.expressOrderPhoto = filePaths.length > 0 ? JSON.stringify(filePaths) : '';
      this.$emit('attachment-change', filePaths);
    },
    handleCollectionUpload: function handleCollectionUpload(filePaths) {
      this.form.expressCollectionPhoto = JSON.stringify(filePaths);
      this.$emit('attachment-change', filePaths);
    },
    handleCollectionDel: function handleCollectionDel(filePaths) {
      this.form.expressCollectionPhoto = filePaths.length > 0 ? JSON.stringify(filePaths) : '';
      this.$emit('attachment-change', filePaths);
    },
    handleChecklistPhotoUpload: function handleChecklistPhotoUpload(filePaths) {
      this.form.deliveryChecklist = JSON.stringify(filePaths);
      this.$emit('attachment-change', filePaths);
    },
    handleChecklistPhotoDel: function handleChecklistPhotoDel(filePaths) {
      this.form.deliveryChecklist = filePaths.length > 0 ? JSON.stringify(filePaths) : '';
      this.$emit('attachment-change', filePaths);
    },
    handleLoadingCompletePhotoUpload: function handleLoadingCompletePhotoUpload(filePaths) {
      this.form.loadingCompletePhoto = JSON.stringify(filePaths);
      this.$emit('attachment-change', filePaths);
    },
    handleLoadingCompletePhotoDel: function handleLoadingCompletePhotoDel(filePaths) {
      this.form.loadingCompletePhoto = filePaths.length > 0 ? JSON.stringify(filePaths) : '';
      this.$emit('attachment-change', filePaths);
    },
    // ==================== $refs methods ====================
    fillFromEdit: function fillFromEdit(row) {
      var _this5 = this;

      if (!row) return;
      this.form.expressDate = row.expectedDeliveryDate || '';
      this.form.expressTime = row.expectedDeliveryTime || '';
      this.form.expressCompany = row.sendCompany || '';
      this.form.expressRemark = row.expressRemark || row.remark || '';
      this.form.expressAttachment = row.expressAttachment || row.attachment || '';
      this.form.expressDeliveryPerson = row.expressDeliveryPerson || '';
      this.form.expressDeliveryTime = row.expressDeliveryTime || '';
      this.form.expressCollectTime = row.expressCollectTime || '';
      this.form.expressTrackingNo = row.expressTrackingNo || '';
      this.form.expressProgress = row.expressProgress || '';
      this.form.expressOrderPhoto = row.expressOrderPhoto || '';
      this.form.expressCollectionPhoto = row.expressCollectionPhoto || '';
      this.form.expressNo = row.expressNo || '';
      this.form.expressReceiveTime = row.expressReceiveTime || '';
      this.form.expressPhoto = row.expressPhoto || '';
      this.form.expressSendNote = row.expressSendNote || '';
      this.form.paymentMethod = row.paymentMethod || row.payWay || '';
      this.form.warehouseLocation = row.warehouseLocation || row.storageLocation || '';
      this.form.deliveryPerson = row.deliveryPerson || row.sender || '';
      this.form.deliveryChecklist = row.deliveryChecklist || '';
      this.form.loadingCompletePhoto = row.loadingCompletePhoto || '';
      this.form.receivePerson = row.receivePerson || this.customerInfo.contactPerson || '';
      this.form.receivePhone = row.receivePhone || this.customerInfo.contactNumber || '';
      this.form.receiveAddress = row.receiveAddress || this.customerInfo.contactAddress || ''; // 恢复附件

      if (row.expressAttachment) {
        this.$nextTick(function () {
          return _this5._restoreAttachment('expressAttachment', row.expressAttachment);
        });
      }

      if (row.expressOrderPhoto) {
        this.$nextTick(function () {
          return _this5._restoreAttachment('expressOrderUpload', row.expressOrderPhoto);
        });
      }

      if (row.expressCollectionPhoto) {
        this.$nextTick(function () {
          return _this5._restoreAttachment('expressCollectionUpload', row.expressCollectionPhoto);
        });
      }

      if (row.deliveryChecklist) {
        this.$nextTick(function () {
          return _this5._restoreAttachment('checklistPhotoUpload', row.deliveryChecklist);
        });
      }

      if (row.loadingCompletePhoto) {
        this.$nextTick(function () {
          return _this5._restoreAttachment('loadingCompletePhotoUpload', row.loadingCompletePhoto);
        });
      }
    },
    fillFromCache: function fillFromCache(saveData) {
      var _this6 = this;

      if (!saveData) return;
      if (saveData.expressDate) this.form.expressDate = saveData.expressDate;
      if (saveData.expressTime) this.form.expressTime = saveData.expressTime;
      if (saveData.expressCompany || saveData.sendCompany) this.form.expressCompany = saveData.expressCompany || saveData.sendCompany;
      if (saveData.expressRemark) this.form.expressRemark = saveData.expressRemark;
      if (saveData.expressAttachment) this.form.expressAttachment = saveData.expressAttachment;
      if (saveData.expressDeliveryPerson) this.form.expressDeliveryPerson = saveData.expressDeliveryPerson;
      if (saveData.expressDeliveryTime) this.form.expressDeliveryTime = saveData.expressDeliveryTime;
      if (saveData.expressCollectTime) this.form.expressCollectTime = saveData.expressCollectTime;
      if (saveData.expressTrackingNo) this.form.expressTrackingNo = saveData.expressTrackingNo;
      if (saveData.expressProgress) this.form.expressProgress = saveData.expressProgress;
      if (saveData.expressOrderPhoto) this.form.expressOrderPhoto = saveData.expressOrderPhoto;
      if (saveData.expressCollectionPhoto) this.form.expressCollectionPhoto = saveData.expressCollectionPhoto;
      if (saveData.expressNo || saveData.expressNumber) this.form.expressNo = saveData.expressNo || saveData.expressNumber;
      if (saveData.expressReceiveTime) this.form.expressReceiveTime = saveData.expressReceiveTime;
      if (saveData.expressPhoto) this.form.expressPhoto = saveData.expressPhoto;
      if (saveData.expressSendNote) this.form.expressSendNote = saveData.expressSendNote;
      if (saveData.paymentMethod || saveData.payWay) this.form.paymentMethod = saveData.paymentMethod || saveData.payWay;
      if (saveData.warehouseLocation || saveData.storageLocation) this.form.warehouseLocation = saveData.warehouseLocation || saveData.storageLocation;
      if (saveData.deliveryPerson || saveData.sender) this.form.deliveryPerson = saveData.deliveryPerson || saveData.sender;
      if (saveData.deliveryChecklist) this.form.deliveryChecklist = saveData.deliveryChecklist;
      if (saveData.loadingCompletePhoto) this.form.loadingCompletePhoto = saveData.loadingCompletePhoto;

      if (saveData.attachment) {
        this.form.expressAttachment = typeof saveData.attachment === 'string' ? saveData.attachment : JSON.stringify(saveData.attachment);
      } // 恢复附件


      if (saveData.expressAttachment) {
        this.$nextTick(function () {
          return _this6._restoreAttachment('expressAttachment', saveData.expressAttachment);
        });
      }
    },
    buildSaveData: function buildSaveData() {
      return {
        expressDate: this.form.expressDate,
        expressTime: this.form.expressTime,
        expressCompany: this.form.expressCompany,
        expressRemark: this.form.expressRemark,
        expressAttachment: this.form.expressAttachment,
        expressDeliveryPerson: this.form.expressDeliveryPerson,
        expressDeliveryTime: this.form.expressDeliveryTime,
        expressCollectTime: this.form.expressCollectTime,
        expressOrderPhoto: this.form.expressOrderPhoto,
        expressTrackingNo: this.form.expressTrackingNo,
        expressCollectionPhoto: this.form.expressCollectionPhoto,
        expressProgress: this.form.expressProgress,
        expressNo: this.form.expressNo,
        expressReceiveTime: this.form.expressReceiveTime,
        expressPhoto: this.form.expressPhoto,
        expressSendNote: this.form.expressSendNote,
        paymentMethod: this.form.paymentMethod,
        warehouseLocation: this.form.warehouseLocation,
        deliveryPerson: this.form.deliveryPerson,
        deliveryChecklist: this.form.deliveryChecklist,
        loadingCompletePhoto: this.form.loadingCompletePhoto
      };
    },
    getSubmitDataPatch: function getSubmitDataPatch(submitData) {
      submitData.sendDate = this.form.expressDate || '';
      submitData.sendTime = this.form.expressTime || '';
      submitData.sendCompany = this.form.expressCompany || '';
      submitData.remark = this.form.expressRemark || '';
      submitData.expressDeliveryPerson = this.form.expressDeliveryPerson || '';
      submitData.expressDeliveryTime = this.form.expressDeliveryTime || '';
      submitData.expressCollectTime = this.form.expressCollectTime || '';
      submitData.expressOrderPhoto = this.form.expressOrderPhoto || '';
      submitData.expressTrackingNo = this.form.expressTrackingNo || '';
      submitData.expressCollectionPhoto = this.form.expressCollectionPhoto || '';
      submitData.expressProgress = this.form.expressProgress || '';
      submitData.deliveryChecklist = this.form.deliveryChecklist || '';
      submitData.loadingCompletePhoto = this.form.loadingCompletePhoto || '';

      if (this.form.expressAttachment) {
        submitData.attachment = this.form.expressAttachment;
      }

      return submitData;
    },
    fillFromSendInfo: function fillFromSendInfo(row) {
      this.fillFromEdit(row);
    },
    buildDeliverySubmitPhoto: function buildDeliverySubmitPhoto() {
      var parseVal = function parseVal(v) {
        if (!v) return v;

        try {
          return JSON.parse(v);
        } catch (_unused2) {
          return v;
        }
      };

      return {
        deliveryDeliveryPerson: this.form.expressDeliveryPerson,
        deliveryDeliveryTime: this.form.expressDeliveryTime,
        expressCollectTime: this.form.expressCollectTime,
        expressOrderPhoto: parseVal(this.form.expressOrderPhoto),
        expressCollectionPhoto: parseVal(this.form.expressCollectionPhoto),
        expressTrackingNo: this.form.expressTrackingNo,
        expressProgress: this.form.expressProgress
      };
    },
    getRules: function getRules() {
      return {
        expressCompany: [{
          required: true,
          message: '请选择寄件公司',
          trigger: 'change'
        }],
        expressDate: [{
          required: true,
          message: '请选择快递上门日期',
          trigger: 'change'
        }],
        expressTime: [{
          required: true,
          message: '请选择期望发货时间',
          trigger: 'change'
        }],
        receivePerson: [{
          required: true,
          message: '请输入收货人',
          trigger: 'blur'
        }],
        receivePhone: [{
          required: true,
          message: '请输入收货人电话',
          trigger: 'blur'
        }, {
          validator: _validate.validatePhone,
          trigger: 'blur'
        }],
        receiveAddress: [{
          required: true,
          message: '收货信息必填',
          trigger: 'change'
        }],
        paymentMethod: [{
          required: true,
          message: '请输入付款方式',
          trigger: 'blur'
        }],
        warehouseLocation: [{
          required: true,
          message: '请输入仓库位置',
          trigger: 'blur'
        }],
        deliveryPerson: [{
          required: true,
          message: '请输入发货人',
          trigger: 'blur'
        }]
      };
    },
    fillDeliveryInfo: function fillDeliveryInfo(deliveryLog) {
      return {
        expressOrderPhoto: deliveryLog.expressOrderPhoto || [],
        expressCollectionPhoto: deliveryLog.expressCollectionPhoto || [],
        expressTrackingNo: deliveryLog.expressTrackingNo || '',
        expressProgress: deliveryLog.expressProgress || '',
        deliveryChecklistPhoto: deliveryLog.deliveryChecklistPhoto || [],
        deliveryLoadingCompletePhoto: deliveryLog.deliveryLoadingCompletePhoto || []
      };
    },
    // ==================== 辅助方法 ====================
    parsePhotoList: function parsePhotoList(data) {
      if (!data) return [];

      try {
        var arr = Array.isArray(data) ? data : typeof data === 'string' ? JSON.parse(data) : [];
        var imgPreviewPrefix = this.$store.getters.imgPreviewPrefix || '';
        return arr.map(function (item) {
          var parsed = typeof item === 'string' ? JSON.parse(item) : item;
          return {
            url: parsed.url || imgPreviewPrefix + parsed.realName,
            name: parsed.alias || parsed.localName || parsed.realName || ''
          };
        });
      } catch (_unused3) {
        return [];
      }
    },
    _restoreAttachment: function _restoreAttachment(refName, data) {
      var ref = this.$refs[refName];
      if (!ref) return;

      try {
        var raw = typeof data === 'string' ? JSON.parse(data) : data;
        var imgPreviewPrefix = this.$store.getters.imgPreviewPrefix || '';
        var filePreviewPrefix = this.$store.getters.filePreviewPrefix || '';
        var files = raw.map(function (item) {
          var parsed = typeof item === 'string' ? JSON.parse(item) : item;
          var name = (parsed.alias || parsed.localName || parsed.realName || '').toLowerCase();
          var isImage = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp'].some(function (e) {
            return name.endsWith(e);
          });
          var prefix = isImage ? imgPreviewPrefix : filePreviewPrefix;
          return {
            realName: parsed.realName,
            url: parsed.url || prefix + parsed.realName,
            type: parsed.type,
            alias: parsed.localName || parsed.alias
          };
        });
        ref.setFileList(files);
      } catch (e) {}
    }
  }
};
exports.default = _default2;